<template>
        <modal class="w-full h-full"  @close="$emit('close')">
        <div class="relative ">
            <button class="absolute pin-t pin-r outline-none m-5 z-40" @click="$emit('close')">
                <img class="h-4" src="@/assets/SVG/cross-partners.svg"/>
            </button>
            <div class="px-8 pt-16">
                <div class="flex text-center justify-center">
                    <p class="text-main-text font-semibold" v-text="question"></p>
                </div>
            </div>
            <div class="p-8 flex flex-row justify-center" slot="footer">
                <button @click="$emit('white_button')" class="inline-block justify-center hover-up font-bold bg-white border border-main-text text-main-text rounded-full px-6 py-3 outline-none">
                    <span>{{whiteButtonText}}</span>
                </button>
                <button @click="$emit('yellow_button')" class="outline-none ml-4 rounded-full hover-up flex flex-row items-center justify-center bg-brand-yellow px-6 text-main-text">
                    <span class="font-semibold">{{yellowButtonText}}</span>
                </button>
            </div>
        </div>
    </modal>

</template>

<script>
import ModalMixin from '../../../mixins/modals.js';
import Modal from '@/views/modals/base-modal';

export default {
  name: 'RefuseToParticipate',
  components: {
    Modal,
  },
  props: {
    whiteButtonText: {
      type: String,
      default: 'Да',
    },
    yellowButtonText: {
      type: String,
      default: 'Нет',
    },

    question: {
      type: String,
      default: 'Вы уверены?',
    },

  },
  mixins: [ModalMixin],

  methods: {
    white_button() {
      this.$emit('white_button');
      this.vale = !this.vale;
    },
    yellow_button() {
      this.$emit('yellow_button');
      this.vale = !this.vale;
    },
  },
};

</script>

<style scoped>

</style>
